import React from "react";
import "./FolderExplorer.scss";
import FolderListView from "./FolderListView/FolderListView";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { notify } from "../Notify/Notify";
import EmptyStates from "../EmptyStates/EmptyStates";
import emptyFolderImage from "../../assets/EmptyStates/empty_folder.svg";
import { connect } from "react-redux";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../common/UserDataReducer";
import dateFormat from "dateformat";
import { Redirect } from "react-router-dom";
import { apolloClient } from "../..";
import { gql } from "@apollo/client";
import UseAnimations from "react-useanimations";
import loadingIcon from "react-useanimations/lib/loading";
import { deepCopy } from "../../helper";

class FolderExplorer extends React.Component {
  state = {
    subFolders: this.props.subFolders[this.props.match.params.folderId] || [],
    isLoading: false,
    editFolder: false,
    updateFolder: {},
    shareFolder: {},
    checkedShareFolder: {},
    totalCheck: 0,
    fileRedirection: false,
    show: false,
    showShareModal: false,
  };

  componentDidMount() {
    // If no subfolders, fetch
    if (!this.props.subFolders[this.props.match.params.folderId]) {
      this.fetchSubFolders();
    }
  }

  fetchSubFolders = (shouldSetIsLoadingToTrue = true) => {
    if (shouldSetIsLoadingToTrue) {
      this.setState({ isLoading: true });
    }

    const folderId = this.props.match.params.folderId;
    const variables = {
      parentFolderId: folderId,
    };
    apolloClient
      .query({
        query: gql`
          query subFolder($parentFolderId: UUID!) {
            subFolders(parentFolderId: $parentFolderId, skip: 0) {
              folderId: id
              id
              approvalRequired
              approvalLevels {
                id
                name
                users {
                  id
                  isActive
                  username
                  firstName
                  lastName
                  email
                  profile {
                    imageUrl: image
                  }
                }
                sequence
              }
              title
              description
              instruction
              color {
                id
                name
              }
              createdBy {
                id
                username
                firstName
                lastName
                email
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              modifiedTs
              parentFolder {
                id
                title
              }
              documentSet {
                id
                file
                title
                inTrash
                documentType {
                  id
                  title
                }
              }
              sharedFolder {
                id
                user {
                  id
                  email
                  username
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                userRole {
                  id
                  name
                }
              }
              pinnedFolder {
                user {
                  id
                }
                folder {
                  id
                  title
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const subFolders = {
          ...this.props.subFolders,
          [folderId]: result.data.subFolders,
        };
        this.props.updateFolders({
          rootFolders: this.props.rootFolders,
          subFolders,
        });
      })
      .catch((e) => {
        // this.setState({isLoading: false})
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  componentDidUpdate(prevProps) {
    // Fetch subfolders if not available
    if (
      !this.state.isLoading &&
      !this.props.subFolders[this.props.match.params.folderId]
    ) {
      this.fetchSubFolders();
      return;
    }

    if (this.props.subFolders[this.props.match.params.folderId]) {
      // If current folder is fetched then only set subfolders to avoid unnecessary renders
      const subFolders =
        this.props.subFolders[this.props.match.params.folderId];
      const prevSubFolders =
        prevProps.subFolders[this.props.match.params.folderId];

      // Check if folder id is changed -> reset subfolders
      if (
        subFolders !== prevSubFolders ||
        this.props.match.params.folderId !== prevProps.match.params.folderId
      ) {
        this.setState({
          subFolders:
            this.props.subFolders[this.props.match.params.folderId] || [],
          isLoading: false,
        });
      }
    } else if (
      this.props.match.params.folderId !== prevProps.match.params.folderId
    ) {
      this.setState({ isLoading: false });
    }
  }

  getTotalDays = (date) => {
    const dateDay = dateFormat(date, "dd");
    const dateMonth = dateFormat(date, "mm");
    const dateYear = dateFormat(date, "yyyy");

    let first = new Date();
    let second = new Date(
      parseInt(dateYear),
      parseInt(dateMonth) - 1,
      parseInt(dateDay)
    );

    const totalDays = Math.round((second - first) / (1000 * 60 * 60 * 24));
    return totalDays;
  };

  onNewFolderAdd = (data, isApprovalRequired = false) => {
    const newlyFolderData = {
      ...data.createFolder.folder,
    };
    this.setState(
      {
        subFolders: [
          ...this.state.subFolders,
          {
            folderId: data.createFolder.folder.id,
            ...newlyFolderData,
          },
        ],
      },
      () => {
        const title = "Success";
        const detail =
          data.createFolder.folder.title + " folder added successfully!";
        const type = "success";
        notify(title, detail, type);
      }
    );

    let subFolders = { ...this.props.subFolders };
    subFolders[this.props.match.params.folderId].push({
      folderId: data.createFolder.folder.id,
      ...data.createFolder.folder,
    });
    // To update hasSubFolders status if the root folder has no subfolders
    const rootFolders = this.props.rootFolders.map((folder) => {
      if (folder.id === this.props.match.params.folderId) {
        return {
          ...folder,
          hasSubFolders:
            subFolders[this.props.match.params.folderId].length !== 0,
        };
      } else {
        return folder;
      }
    });

    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: subFolders,
    });
  };
  onApprovalAddedForAFolder = (folderId = "", approvalLevels = []) => {
    const { subFolders } = this.state;
    const currentFolder = subFolders.find(
      (subFolder) => subFolder.folderId === folderId
    );

    if (!currentFolder) {
      return;
    }
    const restFolder = subFolders.filter(
      (subFolder) => subFolder.folderId !== folderId
    );
    currentFolder["approvalLevels"] = approvalLevels;
    this.setState(
      {
        subFolders: [...restFolder, { ...currentFolder }],
      },
      () => {
        const title = "Success";
        const detail = "Approval level added successfully!";
        const type = "success";
        notify(title, detail, type);
      }
    );
  };
  onFolderUpdated = (data) => {
    let rootFolders = [...this.props.rootFolders];
    let subFolders = { ...this.props.subFolders };

    if (data.parentFolderId === null) {
      const findFolderIndex = rootFolders.findIndex(
        (folder) => folder.id === data.editFolder.id
      );
      if (findFolderIndex > -1) {
        rootFolders.splice(findFolderIndex, 1);
        rootFolders.splice(findFolderIndex, 0, data.editFolder);
      }
    } else {
      const subFolderArr = subFolders[data.parentFolderId];
      const findSubFolderIndex = subFolderArr.findIndex(
        (subFolder) => subFolder.id === data.editFolder.id
      );
      if (findSubFolderIndex > -1) {
        const subFolder = subFolderArr[findSubFolderIndex];
        subFolder.title = data.editFolder.title;
        subFolder.color = data.editFolder.color;
        subFolder.description = data.editFolder.description;
        subFolder.instruction = data.editFolder.instruction;
        subFolder.approvalRequired = data.editFolder.approvalRequired;
        subFolder.approvalLevels = data.editFolder.approvalLevels ?? [];
        subFolderArr.splice(findSubFolderIndex, 1);
        subFolderArr.splice(findSubFolderIndex, 0, subFolder);
      }
    }

    this.setState({ editFolder: false, updateFolder: {} });
    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: deepCopy(subFolders),
    });
  };

  onArchiveItem = (data) => {
    let rootFolders = [...this.props.rootFolders];
    let subFolders = { ...this.props.subFolders };

    if (data.parentFolder === null) {
      const findFolderIndex = rootFolders.findIndex(
        (folder) => folder.id === data.id
      );
      if (findFolderIndex > -1) {
        rootFolders.splice(findFolderIndex, 1);
      }
    }

    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: subFolders,
    });

    this.setState({ fileRedirection: true });

    // goBack(this.props.history, "/files");
    // this.props.history.push("/files");
  };

  setEditFolder = (bool, folder, isEditingASubFolder = false) => {
    this.setState({
      show: !this.state.show,
      editFolder: bool,
      updateFolder: { ...folder },
    });
    this.props.handleIsEditingASubFolder(isEditingASubFolder);
  };

  handleShareModal = () => {
    if (this.state.totalCheck > 0) {
      this.setState({
        totalCheck: 0,
        showShareModal: !this.state.showShareModal,
        shareFolder: {},
      });
    } else {
      this.setState({
        showShareModal: !this.state.showShareModal,
      });
    }
  };

  setShareFolder = (folder) => {
    this.setState({
      showShareModal: !this.state.showShareModal,
      shareFolder: { ...folder },
    });
  };

  setShareFolders = (checked, totalCheck) => {
    this.setState({
      showShareModal: !this.state.showShareModal,
      checkedShareFolder: checked,
      totalCheck: totalCheck,
    });
  };

  setSubfolders = (subFolderArr) => {
    let rootFolders = [...this.props.rootFolders];
    let subFolders = { ...this.props.subFolders };
    const parentFolderId = this.props.match.params.folderId;
    const newSubFolderArr = subFolders[parentFolderId];
    const filterSubArr = newSubFolderArr.filter(
      (newSub) => subFolderArr.findIndex((sub) => sub.id === newSub.id) > -1
    );
    subFolders[parentFolderId] = [...filterSubArr];
    // To update hasSubFolders status if the root folder has no subfolders
    rootFolders = rootFolders.map((folder) => {
      if (folder.id === parentFolderId) {
        return { ...folder, hasSubFolders: filterSubArr.length !== 0 };
      } else {
        return folder;
      }
    });

    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: subFolders,
    });
  };

  handleFolderModal = (value) => {
    this.setState({
      show: typeof value !== "boolean" ? !this.state.show : Boolean(value),
    });
  };

  createSub = () => {
    this.handleFolderModal();
    this.setState({
      editFolder: false,
      updateFolder: {},
    });
  };

  sortedSubFolders = (subArr) => {
    return subArr.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase()
        ? 1
        : a.title.toLowerCase() < b.title.toLowerCase()
        ? -1
        : 0
    );
  };

  render() {
    const emptyStateButtons = [
      {
        buttonName: "Create Sub Folder",
        buttonToggle: "modal",
        buttonTarget: "#MyModal1",
        clickMethod: this.createSub,
      },
    ];

    if (this.state.fileRedirection) {
      window.history.go(1);
      return <Redirect to={"/files"} />;
    }

    return (
      <div className="container-fluid folderview-wraper" id="style-scroll">
        <Breadcrumbs
          itemsCount={this.state.subFolders.length}
          isFolderView={true}
          rootFolderId={this.props.match.params.folderId}
          subFolderId={this.props.match.params.subId}
          onNewFolderAdded={this.onNewFolderAdd}
          onApprovalAddedForAFolder={this.onApprovalAddedForAFolder}
          onFolderUpdated={this.onFolderUpdated}
          editFolder={this.state.editFolder}
          setEditFolder={this.setEditFolder}
          setShareFolder={this.setShareFolder}
          updateFolder={this.state.updateFolder}
          shareFolder={this.state.shareFolder}
          setShareFolders={this.setShareFolders}
          totalCheck={this.state.totalCheck}
          checkedShareFolder={this.state.checkedShareFolder}
          getTotalDays={this.getTotalDays}
          onArchiveItem={this.onArchiveItem}
          showShareModal={this.state.showShareModal}
          handleShareModal={this.handleShareModal}
          showFolderModal={this.state.show}
          handleFolderModal={this.handleFolderModal}
          isEditingASubFolder={this.props.isEditingASubFolder}
          fetchSubFolders={this.fetchSubFolders}
          {...this.props}
        />
        {this.state.isLoading ? (
          <div className="folder-loader">
            <UseAnimations
              className="loading-icon"
              animation={loadingIcon}
              autoplay={true}
              loop={true}
              strokeColor="Black"
              size={40}
            />
          </div>
        ) : this.state.subFolders.length > 0 ? (
          <FolderListView
            {...this.props}
            subFolders={this.sortedSubFolders(this.state.subFolders)}
            rootFolderId={this.props.match.params.folderId}
            setEditFolder={this.setEditFolder}
            setShareFolder={this.setShareFolder}
            setShareFolders={this.setShareFolders}
            getTotalDays={this.getTotalDays}
            setSubfolders={this.setSubfolders}
            handleShareModalCheck={this.handleShareModal}
            objSubFolders={this.props.subFolders}
            isEditingASubFolder={this.props.isEditingASubFolder}
          />
        ) : (
          <div className="is-size-h2 bold no-folders">
            <EmptyStates
              imgSrc={emptyFolderImage}
              emptyStateTitle="Looks like this Root Folder is empty"
              emptyStateButtons={emptyStateButtons || []}
              {...this.props}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FolderExplorer);
